import { MessageService } from 'primeng/api';

import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';

import { Race } from '../../../models/race';
import { RaceClass } from '../../../models/race-class';
import { REGISTRATION_SOURCE, User } from '../../../models/user';
import { AuthService } from '../../../services/auth.service';
import { RegistrationService } from '../../../services/registration.service';
import { SettingsService } from '../../../services/settings.service';
import { CommonService } from '../../../services/common.service';
import { ClassUser } from '../../../models/class-user';
import { formEvent } from '../form/form/form.component';
import { Registration } from '../../../models/registration';

@Component({
  selector: 'race-add-registration-by-org',
  templateUrl: './add-registration-by-org.component.html',
  styleUrls: ['./add-registration-by-org.component.scss'],
})
export class AddRegistrationByOrgComponent {
  @Input() race: Race | null = null;
  @Input() raceClasses: RaceClass[] = [];
  @Input() selectedClass: RaceClass | undefined;
  @Input() disable: boolean = false;
  @Input() user: User | null = null;

  dialogNewCompetitor: boolean = false;
  newCompetitor: User | undefined;
  showProfile: boolean = false;

  displayRegForm: boolean = false;
  selectedUser: User | null = null;
  selectedRegistration: ClassUser | null = null;
  currentRaceClass: string | null = null;

  phoneNumber: string = '';
  countryCode: string = 'ru';
  input: any;
  competitorPhone: any;

  constructor(
    private registrationService: RegistrationService,
    public settingsService: SettingsService,
    public commonService: CommonService,
    public authService: AuthService,
    private messageService: MessageService
  ) {
  }

  hasError(err: boolean) {
    // Not used with new component
  }

  telInputObject(input: any) {
    this.input = input;
  }

  setPhone() {
    this.competitorPhone = this.phoneNumber;
  }

  onCountryChange(event: any) {
    this.countryCode = event.iso2.toLowerCase();
    this.messageService.clear();
    this.phoneNumber = '';
  }

  onPhoneNumberChange(phoneNumberData: any) {
    this.phoneNumber = phoneNumberData.value || '';
    this.setPhone();
  }

  async searchCompetitor() {
    if (!this.competitorPhone) return;
    const phone = this.competitorPhone;
    this.registrationService
      .searchCompetitor(phone)
      .then((cUid) => {
        if (cUid) {
          this.registrationService
            .getUser(cUid)
            .then((user) => {
              if (user) {
                user.phone = phone;
                this.commonService.confirm({
                  header:
                    this.settingsService.translate[
                      this.settingsService.selectedLang
                    ]['add_reg'],
                  message: `${user.name} ${user.city} ${user.age.str_age}`,
                  acceptLabel:
                    this.settingsService.translate[
                      this.settingsService.selectedLang
                    ]['yes'],
                  rejectLabel:
                    this.settingsService.translate[
                      this.settingsService.selectedLang
                    ]['no'],
                  accept: () => {
                    this.fillRegistrationData(user);
                  },
                  reject: () => {},
                });
              }
              this.competitorPhone = null;
              this.input.setNumber('');
            });
        } else {
          this.commonService.confirm({
            header:
              this.settingsService.translate[this.settingsService.selectedLang][
                'new_user'
              ],
            message:
              this.settingsService.translate[this.settingsService.selectedLang][
                'add_new_competitor'
              ],
            acceptLabel:
              this.settingsService.translate[this.settingsService.selectedLang][
                'yes'
              ],
            rejectLabel:
              this.settingsService.translate[this.settingsService.selectedLang][
                'no'
              ],
            accept: () => {
              const newCompetitor = new User({
                phone: phone.split('+')[1],
                registrationSource: REGISTRATION_SOURCE.ADDED_IN_CREW,
              });
              newCompetitor.phoneOld = newCompetitor.phone;
              newCompetitor.registrationSource =
                REGISTRATION_SOURCE.ADDED_IN_CREW;
              this.newCompetitor = newCompetitor;
              this.showProfile = true;
              this.dialogNewCompetitor = true;
            },
            reject: () => {
              this.dialogNewCompetitor = false;
            },
          });
        }
      });
  }

  async onUserSaved(user: User | null) {
    if (user) {
      this.newCompetitor = undefined;
      this.dialogNewCompetitor = false;
      this.fillRegistrationData(user);
    }
  }

  fillRegistrationData(user: User) {
    if (this.selectedClass) {
      const blockreg = this.selectedClass.checkDataUserForReg(
        user,
        this.race?.date
      );
      if (!blockreg.error) {
        if (!this.selectedClass || !this.race?.rUid || !user) return;
        const oldRegistration = this.raceClasses
        .reduce<Registration[]>((acc, raceClass) => acc.concat(raceClass.registrations), [])
        .find(registration => registration.user.cUid === user.cUid);
        this.selectedUser = user;
        this.selectedRegistration = new ClassUser(
          user.cUid,
          oldRegistration ? oldRegistration.clUid : null,
          oldRegistration ? Number(oldRegistration.startNumber) : null,
          oldRegistration ? oldRegistration.info : null
        );
        this.currentRaceClass = oldRegistration?.clUid || null;
        this.selectedRegistration.saved = false;
        this.selectedRegistration.user = user;
        this.displayRegForm = true;
      } else {
        if (blockreg.limit) {
          this.messageService.add({
            severity: 'error',
            summary:
              this.settingsService.translate[this.settingsService.selectedLang][
                'no_places'
              ],
            detail:
              this.settingsService.translate[this.settingsService.selectedLang][
                'error'
              ],
          });
        }
        if (blockreg.ageMax || blockreg.ageMin) {
          this.messageService.add({
            severity: 'error',
            summary:
              this.settingsService.translate[this.settingsService.selectedLang][
                'error'
              ],
            detail:
              this.settingsService.translate[this.settingsService.selectedLang][
                'error_age'
              ],
          });
        }
        if (blockreg.gender) {
          this.messageService.add({
            severity: 'error',
            summary:
              this.settingsService.translate[this.settingsService.selectedLang][
                'error'
              ],
            detail:
              this.settingsService.translate[this.settingsService.selectedLang][
                'req_gender'
              ],
          });
        }
      }
    }
  }

  closeRegistrationDataDialog(event: formEvent) {
    this.displayRegForm = false;
    this.commonService.closeRegistrationDialog.emit();
  }
}
